export default {
    namespaced: true,
    state: {
        newImageGroup:null,
        selectedImageId:null
    },
    mutations: {
        'selectedImage': (state, value) => {
            state.selectedImageId = value;
        },
        'imageGroup':(state,value)=>{
            state.newImageGroup = value;
        }
    },
    getters: {
        imageGroup: state => state.newImageGroup,
        selectedImageId: state => state.selectedImageId
    },
    actions:{
        resetStore ({ commit }) {
            commit('imageGroup', null)
            commit('selectedImage', null)
        }
    }
}